import { ReactComponent as Merchant } from '../../../svgs/merchant.svg';
import { ReactComponent as Key } from '../../../svgs/key.svg';
import { ReactComponent as SMS } from '../../../svgs/sms.svg';
import { ReactComponent as Log } from '../../../svgs/log.svg';
import { ReactComponent as Dashboard } from '../../../svgs/home.svg';
// import { ReactComponent as Credit } from '../../../svgs/credit.svg';
import { ReactComponent as LookUp } from '../../../svgs/lookup.svg';
import { ReactComponent as Logout } from '../../../svgs/logout.svg';
import { NavLink } from 'react-router-dom';
import styles from './sidebar.module.scss';
import { useActionCreator } from '../../../hooks/useActionCreator';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const activeStyle = {
	borderRadius: '5px',
	backgroundColor: 'var(--color-button-bg)',
	color: '#FFFFFF',
	border: 'none',
	svg: {
		fill: '#FFFFFF',
		backgroundColor: 'red',
	},
};

const Sidebar = ({ closeSidebar }: { closeSidebar: () => void }) => {
	const { logout } = useActionCreator();
	const role = useSelector((state: RootState) => state?.user?.role) as string;

	const handleLogout = () => {
		logout();
		closeSidebar();
	};

	return (
		<main className={styles.nav}>
			<div className={styles.logoWrapper}></div>
			<hr className={styles.space} />

			<NavLink
				style={({ isActive }) => (isActive ? activeStyle : {})}
				className={styles.navLink}
				to={'/dashboard'}
				onClick={closeSidebar}
			>
				{({ isActive }) => (
					<>
						<Dashboard className={isActive ? styles.activeIcon : ''} />
						<span>Dashboard</span>
					</>
				)}
			</NavLink>

			{role === 'ADMIN' && (
				<NavLink
					style={({ isActive }) => (isActive ? activeStyle : {})}
					className={styles.navLink}
					to={'/merchants'}
					onClick={closeSidebar}
				>
					{({ isActive }) => (
						<>
							<Merchant className={isActive ? styles.activeIcon : ''} />
							<span>Merchant</span>
						</>
					)}
				</NavLink>
			)}

			<NavLink
				style={({ isActive }) => (isActive ? activeStyle : {})}
				className={styles.navLink}
				to={'/apikey'}
				onClick={closeSidebar}
			>
				{({ isActive }) => (
					<>
						<Key className={isActive ? styles.activeIcon : ''} />
						<span>API Key</span>
					</>
				)}
			</NavLink>

			<NavLink
				style={({ isActive }) => (isActive ? activeStyle : {})}
				className={styles.navLink}
				to={'/send-sms'}
				onClick={closeSidebar}
			>
				{({ isActive }) => (
					<>
						<SMS className={isActive ? styles.activeIcon : ''} />
						<span>Send SMS</span>
					</>
				)}
			</NavLink>
			{role === 'ADMIN' && (
				<NavLink
					style={({ isActive }) => (isActive ? activeStyle : {})}
					className={styles.navLink}
					to={'/transaction-report'}
					onClick={closeSidebar}
				>
					{({ isActive }) => (
						<>
							<Log className={isActive ? styles.activeIcon : ''} />
							<span>SMS Report</span>
						</>
					)}
				</NavLink>
			)}
			<NavLink
				style={({ isActive }) => (isActive ? activeStyle : {})}
				className={styles.navLink}
				to={'/transaction-log'}
				onClick={closeSidebar}
			>
				{({ isActive }) => (
					<>
						<Log className={isActive ? styles.activeIcon : ''} />
						<span>Transaction Log</span>
					</>
				)}
			</NavLink>
			{/* <NavLink
				style={({ isActive }) => (isActive ? activeStyle : {})}
				className={styles.navLink}
				to={'/sms-credit'}
				onClick={closeSidebar}
			>
				{({ isActive }) => (
					<>
						<Credit className={isActive ? styles.activeIcon : ''} />
						<span>SMS Credit</span>
					</>
				)}
			</NavLink> */}
			<NavLink
				style={({ isActive }) => (isActive ? activeStyle : {})}
				className={styles.navLink}
				to={'/network-lookup'}
				onClick={closeSidebar}
			>
				{({ isActive }) => (
					<>
						<LookUp className={isActive ? styles.activeIcon : ''} />
						<span>Network Look-Up</span>
					</>
				)}
			</NavLink>

			<NavLink
				style={({ isActive }) => (isActive ? activeStyle : {})}
				className={styles.navLinklogout}
				to='/'
				onClick={handleLogout}
			>
				{({ isActive }) => (
					<>
						<Logout className={isActive ? styles.activeIcon : ''} />
						<span>Logout</span>
					</>
				)}
			</NavLink>
		</main>
	);
};

export default Sidebar;
